import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class AwsProvider extends HttpService {

    /**
     * Serviço de integração ao backend da AWS
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('aws', http, settingsService);
    }

}
